import { createContext } from 'react';
import { NominationFormContextType } from './NominationFormContext.types';

export const NominationFormContext = createContext<NominationFormContextType | undefined>(undefined);
